import {
  BooleanInput,
  Edit,
  FormDataConsumer,
  Loading,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useDataProvider,
  useGetList,
  useRedirect,
  useRefresh,
  useTranslate
} from 'react-admin'
import {
  filter,
  // find,
  flow,
  isEmpty,
  isNil,
  map,
  replace,
  size,
  split
  // toNumber
} from 'lodash/fp'
import React, { useState } from 'react'
import { assign } from 'lodash'
import log from 'loglevel'
import { Divider, Grid, Typography } from '@mui/material'

import { Title } from '../Util'
import { Partner, PartnerUser, Product } from '../../types'
import { CardCreateOrEditDialog } from '../Credit'

type PartnerInput = Partner & {
  count?: number
  houseNames?: string[]
  customerNumbers?: string[]
  deletes?: boolean[]
}
type CodeFind = {
  partner: Partner
  products: Product[]
}

// const DEFAULT_CONTINUOUS_LIMIT = 3
// const DEFAULT_THRESHOLD = 10

const PartnerEditToolbar: React.FC = () => (
  <Toolbar>
    <SaveButton label="mine.partners.next" />
  </Toolbar>
)
// const checkCriterion = (
//   user: PartnerUser,
//   products: Product[],
//   baseUser: PartnerUser | undefined
// ): void => {
//   const { product, criterionsAll } = user
//   if (isNil(products)) return
//   const productKind = toNumber(split('-')(product)[5])
//   log.debug('[../Partner/index:checkCriterion]', {
//     user,
//     products,
//     productKind
//   })
//   const { criterions } = user
//   const selectedProduct = products[productKind]
//   if (isNil(selectedProduct)) {
//     return
//   }
//   if (isNil(criterions[0])) {
//     let baseCriterions
//     if (
//       !isNil(baseUser) &&
//       !isNil(baseUser.criterionsAll) &&
//       baseUser.criterionsAll
//     ) {
//       baseCriterions = baseUser.criterions
//     } else {
//       baseCriterions = selectedProduct.criterions
//     }
//     for (let i = 0; i < baseCriterions.length; i++) {
//       const {
//         startDate,
//         endDate,
//         start,
//         end,
//         enabled,
//         continuousLimit,
//         threshold
//       } = baseCriterions[i] as Criterion
//       if (!isNil(enabled) && enabled) {
//         if (
//           isNil(startDate) ||
//           isNil(endDate) ||
//           isNil(start) ||
//           isNil(end) ||
//           isNil(continuousLimit) ||
//           isNil(threshold)
//         ) {
//           continue
//         }
//         criterions.push({
//           startDate,
//           endDate,
//           start,
//           end,
//           enabled,
//           continuousLimit: isNil(continuousLimit)
//             ? DEFAULT_CONTINUOUS_LIMIT
//             : continuousLimit,
//           threshold: isNil(threshold) ? DEFAULT_THRESHOLD : threshold
//         })
//       }
//     }
//   }
//   if (isNil(criterionsAll)) {
//     user.criterionsAll =
//       !isNil(baseUser) &&
//       !isNil(baseUser.criterionsAll) &&
//       baseUser.criterionsAll
//         ? baseUser.criterionsAll
//         : selectedProduct.criterionsAll
//   }
//   log.debug('[../Partner/index:checkCriterion]', { criterions })
// }
const HouseInput:
  | React.FC<{
      count?: number
      users: PartnerUser[] | undefined
      customerNumbers: string[]
      register?: boolean | undefined
    }>
  | undefined = ({ count, users, customerNumbers, register }) => {
  // const dataProvider = useDataProvider()
  const checkSpin =
    (currentCustomerNumber: string | undefined) =>
    async (customerNumber: string): Promise<string | undefined> => {
      if (customerNumber.length !== 13) return 'too short customer number'
      const spin = `040${customerNumber}000000`
      const current = !isNil(currentCustomerNumber)
        ? `040${currentCustomerNumber}000000`
        : null
      if ((!isNil(current) && current === spin) || spin.length < 22) {
        return undefined
      }
      const duplicate = filter((item: string) => customerNumber === item)(
        customerNumbers
      )
      log.debug({ duplicate })
      if (duplicate.length > 1) return 'spin exists'
      return undefined
      // const { data: currentUsers } = await dataProvider.getList('users', {
      //   pagination: { page: 1, perPage: 10 },
      //   filter: { spin },
      //   sort: { field: 'spin', order: 'ASC ' }
      // })
      // log.debug('[checkSpin]', { currentUsers })
      // if (
      //   isNil(currentUsers) ||
      //   isEmpty(currentUsers) ||
      //   currentUsers.length === 1
      // ) {
      //   return undefined
      // }
      // return 'spin exists'
    }
  if (isNil(count)) {
    return <></>
  }
  const inputs = []

  for (let i = 0; i < count; i++) {
    const userData =
      !isNil(users) && !isEmpty(users) && !isNil(users[i]) ? users[i] : null
    inputs.push(
      <Grid container justifyContent="center" key={`house${i}`}>
        <Grid item xs={12} sx={{ marginBottom: '1em' }}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            ハウス{String.fromCharCode('①'.charCodeAt(0) + i)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source={`houseNames.${i}`}
            label="resources.users.fields.houseName"
            fullWidth
            validate={required()}
            defaultValue={
              !isNil(userData) ? replace(/^.*#/, '')(userData.name) : ''
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source={`customerNumbers.${i}`}
            label="resources.users.fields.customerNumber"
            fullWidth
            validate={[
              required(),
              checkSpin(!isNil(userData) ? userData.customerNumber : undefined)
            ]}
            defaultValue={!isNil(userData) ? userData.customerNumber : ''}
          />
        </Grid>
        {(isNil(register) || !register) && (
          <Grid item sx={{ marginLeft: 'auto' }}>
            <BooleanInput
              source={`deletes.${i}`}
              label="resources.users.fields.delete"
              disabled={!isNil(users) && i >= users.length}
            />
          </Grid>
        )}
      </Grid>
    )
  }
  return <>{inputs}</>
}

export const PartnerEdit: React.FC<{
  title?: string
  id: string
  resource: string
  register?: boolean
}> = ({ title, id, resource, register }) => {
  const refresh = useRefresh()
  const redirect = useRedirect()
  const translate = useTranslate()
  const dataProvider = useDataProvider()
  const [users, setUsers] = React.useState<PartnerUser[]>([])
  const { data, isLoading } = useGetList('users', {
    pagination: { page: 1, perPage: 100 },
    filter: { partner: id }
  })
  React.useEffect(() => {
    log.debug('[PartnerEdit]', { data, isLoading })
    if (isLoading) return
    setUsers(data as PartnerUser[])
  }, [data, isLoading])
  const [dialogOpen, setDialogOpen] = useState(false)
  if (isLoading) return <Loading />
  const setCode = async (code: string): Promise<CodeFind[] | undefined> => {
    const { data: partners } = await dataProvider.getList('partners', {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'name', order: 'ASC' },
      filter: {}
    })
    log.debug('[PartnerEdit]', { partners })
    const products = flow([
      map((partner: Partner) => {
        const products = filter((product: Product) => product.code === code)(
          partner.products
        )
        return !isEmpty(products) ? { partner, products } : []
      }),
      filter((item) => !isEmpty(item))
    ])(partners)
    return !isEmpty(products) ? products : undefined
  }
  const zenkaku2hankaku = (str: string): string => {
    return replace(/[Ａ-Ｚａ-ｚ０-９]/g, (str) => {
      return String.fromCharCode(str.charCodeAt(0) - 0xfee0)
    })(str)
  }
  const transform = async (input: PartnerInput): Promise<PartnerInput> => {
    const {
      id: partner,
      name,
      phone,
      count,
      houseNames,
      customerNumbers,
      deletes,
      code
    } = input
    if (isNil(count)) {
      return input
    }
    let { products } = input
    if (!isNil(register) && register) {
      if (!isNil(code)) {
        const tmp = await setCode(zenkaku2hankaku(code))
        log.debug('[PartnerEdit]', { tmp })
        if (!isNil(tmp) && !isEmpty(tmp) && !isNil(tmp[0])) {
          products = tmp[0].products
          assign(input, { products })
          assign(input, { codePartner: tmp[0].partner.id })
        }
      }
    }
    if (!isNil(users)) {
      const update = []
      if (isEmpty(users) || count > users.length) {
        const { data: transaction } = await dataProvider.create(
          'transactions',
          {
            data: {
              count: count - users.length,
              done: 0
            }
          }
        )
        const { id: transactionId } = transaction
        // const baseUser = find(
        //   (user: PartnerUser) =>
        //     !isNil(user.criterionsAll) && user.criterionsAll
        // )(users)
        for (let i = users.length; i < count; i++) {
          const product = `${partner}-0`
          const customerNumber =
            !isNil(customerNumbers) && !isNil(customerNumbers[i])
              ? customerNumbers[i]
              : null
          const spin = !isNil(customerNumber)
            ? `040${customerNumber}000000`
            : null
          const user = {
            name: `${name}#${
              (!isNil(houseNames) && !isNil(houseNames[i])
                ? houseNames[i]
                : '') as string
            }`,
            sms: phone as string,
            phone: phone as string,
            customerNumber: !isNil(customerNumber) ? customerNumber : '',
            contractNumber: !isNil(customerNumber) ? customerNumber : '',
            spin: !isNil(spin) ? spin : '',
            partner,
            product,
            criterions: []
          }
          // checkCriterion(user, products as Product[], baseUser)
          assign(user, { type: 'terashiteA' })
          assign(user, { transactionId })
          log.debug('[transform]', { user })
          const { data } = await dataProvider.create('users', {
            data: { user }
          })
          update.push(data)
        }
      }
      if (!isEmpty(users)) {
        const deletesNum = size(filter((item) => item)(deletes))
        if (deletesNum > 0) {
          const { data: transaction } = await dataProvider.create(
            'transactions',
            {
              data: {
                count: deletesNum,
                done: 0
              }
            }
          )
          const { id: transactionId } = transaction
          for (let i = 0; i < users.length; i++) {
            const deleteThis = !isNil(deletes) ? deletes[i] : false
            if (!isNil(deleteThis) && deleteThis) {
              const { id } = users[i] as PartnerUser
              const input = { id, deleted: true, transactionId }
              const { data } = await dataProvider.update('users', {
                id,
                data: input,
                previousData: users[i]
              })
              update.push(data)
            } else {
              update.push(users[i])
            }
          }
        }
        for (let i = 0; i < users.length; i++) {
          const deleteThis = !isNil(deletes) ? deletes[i] : false
          if (!isNil(deleteThis) && !deleteThis) {
            const houseName = `${name}#${
              (!isNil(houseNames) && !isNil(houseNames[i])
                ? houseNames[i]
                : '') as string
            }`
            const customerNumber = !isNil(customerNumbers)
              ? customerNumbers[i]
              : ''
            const spin = !isNil(customerNumber)
              ? `040${customerNumber}000000`
              : ''
            const user = users[i] as PartnerUser
            const { id } = user
            const input = { id }
            if (houseName !== user.name) {
              assign(input, { name: houseName })
            }
            if (spin !== user.spin) {
              assign(input, {
                spin,
                customerNumber,
                contractNumber: customerNumber
              })
            }
            log.debug('[PartnerEdit]', { input })
            if (houseName !== user.name || spin !== user.spin) {
              const { data } = await dataProvider.update('users', {
                id,
                data: input,
                previousData: users[i]
              })
              update.push(data)
            } else {
              update.push(users[i])
            }
          }
        }
      }
      setUsers(update)
      // setUsersCount(update.length)
    }

    delete input.count
    delete input.customerNumbers
    delete input.houseNames
    if (!isNil(process.env['REACT_APP_NO_GMO'])) {
      assign(input, { gmoCardSeq: 'none' })
    }
    return input
  }
  const onSuccess = async (): Promise<void> => {
    if (!isNil(register) && register) {
      if (!isNil(process.env['REACT_APP_NO_GMO'])) {
        refresh()
        redirect(`/${id}`)
      } else {
        setDialogOpen(true)
      }
    } else {
      refresh()
      redirect(`/${id}`)
    }
  }
  const checkCode = async (code: string): Promise<string | undefined> => {
    if (isNil(code) || code === 'null') return undefined
    const products = await setCode(zenkaku2hankaku(code))
    return !isNil(products) && !isEmpty(products)
      ? undefined
      : 'not existing code'
  }
  return (
    <Edit
      id={id}
      resource={resource}
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess }}
      transform={transform}
      title={<Title title={!isNil(title) ? title : 'mine.partners.title'} />}>
      <SimpleForm toolbar={<PartnerEditToolbar />}>
        <TextInput source="name" fullWidth />
        <TextInput source="phone" fullWidth />
        {!isNil(register) && register && (
          <>
            <TextInput source="code" validate={checkCode} fullWidth />
          </>
        )}
        <NumberInput
          source="count"
          fullWidth
          defaultValue={!isNil(data) ? data.length : 1}
          min={!isNil(users) ? users.length : 1}
        />
        <FormDataConsumer>
          {({ formData }) => {
            // log.debug({ formData })
            return (
              <HouseInput
                count={formData.count}
                users={users}
                customerNumbers={formData.customerNumbers}
                register={register}
              />
            )
          }}
        </FormDataConsumer>
        <div style={{ marginBottom: '5em' }} />
      </SimpleForm>
      <CardCreateOrEditDialog
        id={id}
        setDialogOpen={setDialogOpen}
        dialogOpen={dialogOpen}
        cardRegister>
        {}
        {map((item: string) => <Typography>{item}</Typography>)(
          split('\n')(translate('mine.credit.dialogs.register'))
        )}
      </CardCreateOrEditDialog>
    </Edit>
  )
}
